export const timeFromNow = (date, local = 'en') => {
  if (!date) return undefined;
  const fromDate = new Date(date);
  if (!(fromDate instanceof Date) || isNaN(fromDate) || !isFinite(fromDate))
    return undefined;
  const difference = fromDate - new Date();
  const units = {
    year: 1000 * 60 * 60 * 24 * 365,
    month: 1000 * 60 * 60 * 24 * (365 / 12),
    day: 1000 * 60 * 60 * 24,
    hour: 1000 * 60 * 60,
    minute: 1000 * 60,
    second: 1000,
  };
  const rtf = new Intl.RelativeTimeFormat(local, { numeric: 'auto' });
  let result;
  for (const unit in units) {
    if (Math.abs(difference) > units[unit] || unit === 'second') {
      result = rtf.format(Math.round(difference / units[unit]), unit);
      break;
    }
  }
  return result;
};
